function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 7h2v5c0 2.47.189 3 1 3 1.304 0 2-.617 2-3 0-5.29-2.654-8-8-8a8 8 0 104.692 14.48l1.173 1.62A10 10 0 1111.999 2c6.462 0 10 3.616 10 10 0 3.545-1.64 5-4 5-1.343 0-2.112-.433-2.535-1.395A5 5 0 1115 8V7zm0 5a3 3 0 11-6 0 3 3 0 016 0z",
  fill: "#000"
});

function SvgAtSign(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgAtSign;